var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreiVonAcetonUndPetroleum = function SvgFreiVonAcetonUndPetroleum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Frei_von_Aceton_und_Petroleum_svg__Ebene_2",
    viewBox: "0 0 111.94 99"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Frei_von_Aceton_und_Petroleum_svg__cls-2{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Frei_von_Aceton_und_Petroleum_svg__Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 99c-.36 0-.71-.14-.98-.41L.41 50.48c-.26-.26-.41-.61-.41-.98s.15-.72.41-.98L48.52.41a1.4 1.4 0 0 1 1.97 0 1.4 1.4 0 0 1 0 1.97L3.36 49.5l47.13 47.13a1.396 1.396 0 0 1-.98 2.38ZM62.44 99c-.36 0-.71-.14-.98-.41a1.4 1.4 0 0 1 0-1.97l47.13-47.13L61.46 2.37a1.4 1.4 0 0 1 0-1.97 1.4 1.4 0 0 1 1.97 0l48.11 48.11c.26.26.41.61.41.98s-.15.72-.41.98L63.43 98.58c-.27.27-.63.41-.98.41Z",
    className: "Frei_von_Aceton_und_Petroleum_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m79.45 47.59-7.92-13.36c-.22-.37-.63-.61-1.08-.61s-.86.23-1.08.61l-7.92 13.36s-.02.04-.04.07c-1.84 3.16-1.83 6.92.03 10.06 1.88 3.17 5.24 5.06 9 5.06s7.12-1.89 9-5.06c.05-.09.09-.18.14-.26.03-.05.05-.11.08-.16.51-.96.86-1.98 1.04-3.01.4-2.32-.04-4.64-1.26-6.69Z",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "2.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.49 47.59-7.92-13.36c-.22-.37-.63-.61-1.08-.61s-.86.23-1.08.61l-7.92 13.36s-.02.04-.04.07c-1.84 3.16-1.83 6.92.03 10.06 1.88 3.17 5.24 5.06 9 5.06s7.12-1.89 9-5.06c.05-.09.09-.18.14-.26.03-.05.05-.11.08-.16.51-.96.86-1.98 1.04-3.01.4-2.32-.04-4.64-1.26-6.69Z",
    style: {
      stroke: "currentColor",
      strokeMiterlimit: 10,
      strokeWidth: "2.39px",
      fill: "none"
    }
  })));
};
export default SvgFreiVonAcetonUndPetroleum;